import styled, { keyframes } from 'styled-components';

import fireIcon from '#src/components/boards/HotStreakTile/assets/fireIcon.svg';
import grayFireIcon from '#src/components/boards/HotStreakTile/assets/grayFireIcon.webp';
import replayIcon from '#src/components/boards/HotStreakTile/assets/replayIcon.webp';
import {
  DIAMOND_HEIGHT,
  DIAMOND_WIDTH,
} from '#src/components/series/SeriesBoard/utils.ts';

const fireIconAnimation = keyframes`
  0% {
    transform: translateY(-10px) translateX(-50%);
  }
  40% {
    transform: translateY(0px) translateX(-50%);
  }
  100% {
    transform: translateY(-10px) translateX(-50%);
  }
`;
export const ReadyIconWrapper = styled.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 20px;

  &.animated {
    animation: ${fireIconAnimation} 4s ease-in-out infinite;
  }
`;
export const ReadyIcon = styled.div`
  width: ${DIAMOND_WIDTH * 1.6}px;
  height: ${DIAMOND_HEIGHT * 1.6}px;
  background: url(${fireIcon}) no-repeat center / contain;

  &.averageMode {
    background: url(${replayIcon}) no-repeat center / contain;
  }
`;
export const ReadyIconLocked = styled.div`
  width: ${DIAMOND_WIDTH * 1.6}px;
  height: ${DIAMOND_HEIGHT * 1.6}px;
  background: url(${grayFireIcon}) no-repeat center / contain;
`;
